import * as Yup from 'yup';
import PropTypes from 'prop-types';

import { useEffect, useState, } from 'react';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from '../components/snackbar';
import LoadingButton from '@mui/lab/LoadingButton';
import { Dialog, TextField, DialogActions, DialogContent, DialogTitle, Alert, Grid, Box, IconButton, Typography, Stack, Tooltip, InputAdornment, } from '@mui/material';
import axios from 'axios';
import Iconify from '../components/iconify';
import { useBoolean } from '../hooks/use-boolean';



// ----------------------------------------------------------------------

export default function DeleteAccount({ isOpen, onClose, userName, ...other }) {
    const SERVER_URI = process.env.REACT_APP_SERVER_URI;
    const DELETE_ACCOUNT = `${SERVER_URI}/delete-account`

    const passwordShow = useBoolean();
    const { enqueueSnackbar } = useSnackbar();

    //   const token = window.localStorage.getItem('accessToken');

    const [errorMsg, setErrorMsg] = useState('');
    const [loading, setLoading] = useState(false);
    const handleCloseDialog = () => {
        onClose()
    };





    const UpdateUserSchema = Yup.object().shape({
        password: Yup.string()
            .min(8, "Password must be at least 8 characters")
            .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
            .matches(/[a-z]/, "Password must contain at least one lowercase letter")
            .matches(
                /[!@#$%^&*(),.?":{}|<>]/,
                "Password must contain at least one special character"
            )
            .required("Password is required"),

    });


    const defaultValues = {
        password: '',
        userName: userName || '',

    };

    const {
        handleSubmit,
        control,
        formState: { isSubmitting, errors, isValid },
        // reset,
        // trigger,
        // getValues,
        setValue
    } = useForm({
        resolver: yupResolver(UpdateUserSchema),
        defaultValues,
        mode: "onChange",
        reValidateMode: "onChange",

    });


    useEffect(() => {
        setValue('userName', userName)
    }, [userName]);

    const onSubmit = handleSubmit(async (data) => {
        let token = localStorage.getItem("accessToken");
        let config = {
            headers: { Authorization: `Bearer ${token}` },
        };
        try {
            setLoading(true);
            const dataSubmit = {
                password: data?.password
            };

            setErrorMsg('');
            console.log("dataSubmit ---->", dataSubmit)

            const response = await axios.delete(DELETE_ACCOUNT, {
                data: dataSubmit,  // Passing JSON payload directly
                headers: { Authorization: `Bearer ${token}` }   
            },
            {
                withCredentials: true,
              }
        );
            handleCloseDialog();
            setErrorMsg('');
            enqueueSnackbar(response.data.message, { variant: 'success' });
            setTimeout(() => {
                window.location.href = "/user_signup";
            }, 4000);
        } catch (error) {
            console.log(error);
            if (!navigator.onLine) {
                setErrorMsg('You are currently offline. Please check your network connection.');
            } else if (error.response.status === 401) {
                enqueueSnackbar(error.response.data.message, { variant: "error" });

            } else if (error) {
                setErrorMsg(error.response.data.error || 'An error occurred while processing your request.');
                enqueueSnackbar(error.response.data.error, { variant: 'error' });
            } else {
                setErrorMsg('An unexpected error occurred.');
            }
        } finally {
            setLoading(false);
        }
    });

    return (
        <>
            <Dialog
                // fullWidth
                maxWidth={false}
                open={isOpen}
                onClose={onClose} {...other}
                disableEscapeKeyDown // Prevent closing with the Escape key

                PaperProps={{
                    sx: { maxWidth: 720, minWidth: { xs: 250, lg: 468 }, borderRadius: 5, p: { md: '28px', xs: '8px' } },
                }}
            >
                <form onSubmit={onSubmit}>
                    <DialogTitle
                        sx={{
                            color: '#1E53E8',
                            fontSize: 24,
                            fontFamily: 'Roboto Flex',
                            fontWeight: '700',
                            lineHeight: '18px',
                            wordWrap: 'break-word',
                        }}
                    >
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }} >
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: { xs: 60, md: 70 },
                                    width: { xs: 60, md: 70 },
                                    borderRadius: '50%',
                                    backgroundColor: '#ffe6e6', // Light red background
                                }}
                            >
                                <Iconify
                                    icon="tdesign:error"
                                    sx={{
                                        color: '#ff4d4d', // Error icon color
                                        fontSize: '2rem',


                                    }}
                                />
                            </Box>

                            <IconButton
                                onClick={handleCloseDialog}
                                sx={{
                                    position: 'absolute',
                                    top: 15,
                                    right: 15,
                                    backgroundColor: '#f1f1f1',
                                    color: '#919191',
                                    transition: 'color 0.3s ease',
                                    '&:hover': {
                                        color: 'red',
                                    },
                                }}
                            >
                                <Iconify icon="material-symbols:close" />
                            </IconButton>
                        </Box>
                    </DialogTitle>


                    <DialogContent sx={{ p: { xs: '8px' } }} >
                        {errorMsg &&
                            <Alert variant="outlined" severity="error" sx={{ mb: 3 }}>
                                {errorMsg}
                            </Alert>}

                        <Grid item xs={12} md={12} sx={{ pt: 2 }}>
                            <Box >
                                <Stack
                                    direction='column'
                                    spacing={1}
                                    sx={{
                                        justifyContent: 'center', // Space between text and button
                                        alignItems: 'center',
                                    }}
                                >
                                    <Typography sx={{
                                        color: '#F03D55',
                                        fontSize: { md: '24px', xs: '18px' },
                                        fontFamily: 'Roboto Flex',
                                        fontWeight: '700',
                                        lineHeight: ' 24px',
                                        wordWrap: 'break-word',
                                        textAlign: 'center'
                                    }}>
                                        Permanently Delete Your Account?
                                    </Typography>
                                    <Typography sx={{
                                        color: '#1F1F1F',
                                        fontSize: { md: '18px', xs: '16px' },
                                        fontFamily: 'Roboto Flex',
                                        fontWeight: '400',
                                        lineHeight: ' 20px',
                                        wordWrap: 'break-word',
                                        textAlign: 'center'
                                    }}>
                                        Please note that deleting your account permanent and is irreversible
                                    </Typography>

                                </Stack>
                                <Box sx={{ mt: 3, backgroundColor: '#f1f1f1', p: { md: '24px', xs: '18px' }, borderRadius: 3 }}>
                                    <Typography sx={{
                                        color: '#1E53E8',
                                        fontSize: { md: '22px', xs: '18px' },
                                        fontFamily: 'Roboto Flex',
                                        fontWeight: '700',
                                        lineHeight: '18px',
                                        wordWrap: 'break-word',
                                        textAlign: { xs: 'center', md: 'left' },
                                        mb: 2,
                                    }}>
                                        Enter your Account Details
                                    </Typography>


                                    <Stack direction={{ md: 'row', xs: 'column' }} spacing={1} >

                                        <Stack direction="column" spacing={1} sx={{ flex: 1 }}>
                                            <Typography
                                                component="label"
                                                htmlFor="userName_text"
                                                sx={{
                                                    fontWeight: 400,
                                                    fontFamily: "Roboto Flex",
                                                    fontSize: "14px",
                                                    color: "#1F1F1F",
                                                }}
                                            >
                                                User Name
                                            </Typography>
                                            <Controller
                                                name="userName"
                                                control={control}
                                                render={({ field }) => (
                                                    <Tooltip title="You can't edit this field" arrow>
                                                        <TextField
                                                            {...field}
                                                            id="userName_text"
                                                            variant="outlined"
                                                            size="medium"
                                                            fullWidth
                                                            error={!!errors.userName}
                                                            helperText={errors.userName?.message}
                                                            InputProps={{
                                                                readOnly: true, // Makes the field read-only
                                                            }}
                                                            sx={{
                                                                "& .MuiOutlinedInput-root": {
                                                                    borderRadius: 3,
                                                                },
                                                            }}
                                                        />
                                                    </Tooltip>
                                                )}
                                            />
                                        </Stack>
                                        <Stack direction="column" spacing={1} sx={{ flex: 1 }}>
                                            <Typography
                                                component="label"
                                                htmlFor="password_text"
                                                sx={{
                                                    fontWeight: 400,
                                                    fontFamily: "Roboto Flex",
                                                    fontSize: "14px",
                                                    color: "#1F1F1F",
                                                }}
                                            >
                                                Password
                                            </Typography>
                                            <Controller
                                                name="password"
                                                control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        id="password_text"
                                                        variant="outlined"
                                                        size="medium"
                                                        fullWidth
                                                        error={!!errors.password}
                                                        helperText={errors.password?.message}
                                                        sx={{
                                                            "& .MuiOutlinedInput-root": {
                                                                borderRadius: 3,
                                                            },
                                                        }}
                                                        type={passwordShow.value ? "text" : "password"}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton onClick={passwordShow.onToggle}>
                                                                        <Iconify
                                                                            icon={
                                                                                passwordShow.value
                                                                                    ? "solar:eye-bold"
                                                                                    : "mdi:eye-off-outline"
                                                                            }
                                                                        />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Stack>
                                    </Stack>
                                </Box>
                            </Box>
                        </Grid>

                    </DialogContent>

                    <DialogActions sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 3 }}>
                        <Grid container item md={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                            <LoadingButton
                                type="submit"
                                variant="contained"
                                loading={isSubmitting || loading}
                                fullWidth
                                disabled={!isValid}
                                sx={{
                                    color: isValid ? "#1E53E8" : "#FFFFFF", // Gray text when disabled
                                    fontWeight: "bold",
                                    background: isValid ? "#C7F760" : "#C1C1C1", // Gray background when disabled
                                    padding: 1,
                                    borderRadius: 2,
                                    transition: 'color 0.3s ease',
                                    '&:hover': {
                                        transition: 'color 0.3s ease',
                                        color: isValid ? '#C7F760' : "#1E53E8",
                                    },
                                }}
                            >
                                Delete Account
                            </LoadingButton>
                        </Grid>
                    </DialogActions>

                </form>
            </Dialog>


        </>
    );
}

DeleteAccount.propTypes = {
    onClose: PropTypes.func,
    isOpen: PropTypes.bool,
    userName: PropTypes.string.isRequired,
};
